import { Component, ViewEncapsulation } from '@angular/core';
import { SchoolTwoColumnLayoutComponent } from '../../../ng2/school/layouts/school-two-column-layout/school-two-column-layout.component';

@Component({
  templateUrl: './admin-layout.component.html',
  selector: 'admin-layout',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AdminLayoutComponent extends SchoolTwoColumnLayoutComponent {}
